import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-common-warnings',
  templateUrl: './common-warnings.component.html',
  styleUrls: ['./common-warnings.component.scss'],
  standalone: false
})
export class CommonWarningsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
